const isLocal = process.env.NODE_ENV === 'development';

export const CLIENT_URL = isLocal ? "http://localhost:8080/files" : "https://p-vault.com:8083/files";
export const BASELINE = isLocal ? "http://localhost:8080/" : "https://p-vault.com:8083/";
export const AFTER_LOGIN = isLocal ? "http://localhost:3000/dashboard" : "https://p-vault.com/dashboard";

export const MMTLOGIN = "https://mmtprep.com:8081/";
